export const FLAG_GETTING_CABIN_CREWS = 'FLAG_GETTING_CABIN_CREWS';
export const GET_CABIN_CREWS = 'GET_CABIN_CREWS';
export const CLEAR_CABIN_CREWS = 'CLEAR_CABIN_CREWS';
export const FLAG_CABIN_CREW_ACTIVITY = 'FLAG_CABIN_CREW_ACTIVITY';
export const GET_CABIN_CREW = 'GET_CABIN_CREW';
export const CLEAR_CABIN_CREW = 'CLEAR_CABIN_CREW';
export const FLAG_GETTING_CABIN_CREWS_TRIPS = 'FLAG_GETTING_CABIN_CREWS_TRIPS';
export const GET_CABIN_CREWS_TRIPS = 'GET_CABIN_CREWS_TRIPS';
export const CLEAR_CABIN_CREWS_TRIPS = 'CLEAR_CABIN_CREWS_TRIPS';
